export const UsersData = `
id
email
givenName
roles
isActive
permissions
`;
